<ng-container>
    <button class="stc-status {{ removeSpaces(config.className) }}" [matTooltip]="config.isShowTooltip ? config.text : ''">
        <span class="{{ config.icon }}" *ngIf="config.isShowIcon"></span>
        <span [ngClass]="{ 'stc-content': config.isTruncate }">{{ config.text | translate }}</span>
    </button>
</ng-container>
